import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type EnrichmentApiCall = WithLegacy<{
  pipelineRunId: string | null;
  contentSourceId: string | null;
  itemId: string | null;
  provider: string | null;
  operation: string | null;
  query: string | null;
  responseStatus: string | null;
  resultCount: number | null;
  durationMs: number | null;
  errorMessage: string | null;
  createdAt: string | null;
  [Type]: 'enrichment-api-calls';
}>;

export const EnrichmentApiCallSchema = withDefaults({
  type: 'enrichment-api-calls',
  fields: [
    { name: 'pipelineRunId', kind: 'attribute', type: 'string' },
    { name: 'contentSourceId', kind: 'attribute', type: 'string' },
    { name: 'itemId', kind: 'attribute', type: 'string' },
    { name: 'provider', kind: 'attribute', type: 'string' },
    { name: 'operation', kind: 'attribute', type: 'string' },
    { name: 'query', kind: 'attribute', type: 'string' },
    { name: 'responseStatus', kind: 'attribute', type: 'string' },
    { name: 'resultCount', kind: 'attribute', type: 'number' },
    { name: 'durationMs', kind: 'attribute', type: 'number' },
    { name: 'errorMessage', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
  ],
});
